module.exports = __webpack_public_path__ + "static/img/2553_phase_function_Paper_PointsHejduk_Prediction.fc0d8ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2553_phase_function_Paper_PointsHejduk_Prediction.png
// module id = a6gw
// module chunks = 0